<template>
  <!--彈出視窗-->
  <v-dialog
      v-model="alertInfo.visible"
      persistent
      :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{alertInfo.title}}
      </v-card-title>
      <v-card-text>
        <span class="title">{{alertInfo.content}}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="alertInfo.showCancel"  color="#ffb128" dark text @click="alertInfo.cancelEvent">取消</v-btn>
        <v-btn color="#0BA7A3" dark text @click="alertInfo.confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'AlertView',
  props: {
    visible: Boolean,
    title: String,
    content: String,
    showCancel: Boolean,
  },
  data() {
    return {
      width: '70%',
    };
  },
  created() {
    console.log(`alert view`);
  },
  computed: {
    ...mapGetters([
      'alertInfo'
    ])
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
